import config from '../config'
const key = '_diandian_OA'

const storage = {
    init () {
        let init = {
            user: ''
        }
        init = JSON.stringify(init)
        localStorage.setItem(key, init)
    },
    status () {
        let json = storage.getItem('user')
        if (json == '' || !json.hasOwnProperty('accessKey') || !json.accessKey || json.accessKey == '') {
            return false
        }
        else {
            return true
        }
    },
    set (data) {
        let json = localStorage.getItem(key)
        if (!json || json == '') {
            storage.init()
            json = localStorage.getItem(key)
        }
        json = JSON.parse(json)
        json = Object.assign({}, json, data)
        json = JSON.stringify(json)
        localStorage.setItem(key, json)
    },
    setItem (name, data) {
        let json = localStorage.getItem(key)
        if (!json || json == '') {
            storage.init()
            json = localStorage.getItem(key)
        }
        json = JSON.parse(json)
        let temp = json[name]
        temp = Object.assign({}, temp, data)
        json[name] = temp
        json = JSON.stringify(json)
        localStorage.setItem(key, json)
    },
    getItem (name) {
        let json = localStorage.getItem(key)
        if (!json || json == '') {
            return ''
        }
        json = JSON.parse(json)
        if (json[name] != '0' && (!json[name] || json[name] == '')) {
            return ''
        }
        return json[name]
    },
    get () {
        let json = localStorage.getItem(key)
        if (!json || json == '') {
            return ''
        }
        json = JSON.parse(json)
        return json
    }
}

export default storage



// WEBPACK FOOTER //
// ./src/storage/storage.js